// extracted by mini-css-extract-plugin
module.exports = {"section":"proposals_section__eG0T3","list":"proposals_list__zgmEh","listItem":"proposals_listItem__SABQG"};